import { WEB_ASSETS } from '@tenfour/contracts'
import s from './ComposerVoiceIcon.module.css'

interface ResponsiveAsset {
  oneX: string
  twoX: string
}

function Artwork({
  asset,
  className,
}: {
  asset: ResponsiveAsset
  className: string
}) {
  return (
    <img
      src={asset.oneX}
      srcSet={`${asset.oneX} 1x, ${asset.twoX} 2x`}
      width={64}
      height={64}
      alt=""
      className={`${s.asset} ${className}`}
      decoding="async"
      aria-hidden="true"
      draggable={false}
    />
  )
}

/**
 * Theme-aware composer microphone/stop artwork shared by every voice trigger.
 * `medallion` (the default) is the clay disc; `plain` is the same glyph lifted
 * out of its medallion — navy on light, cream on dark, no disc — which the
 * design system's Scribe orb carries on its own surface.
 */
export function ComposerVoiceIcon({
  mode = 'mic',
  variant = 'medallion',
  className,
}: {
  mode?: 'mic' | 'stop'
  variant?: 'medallion' | 'plain'
  className?: string
}) {
  const assets =
    variant === 'plain'
      ? mode === 'stop'
        ? WEB_ASSETS.icons.composer.stopPlain
        : WEB_ASSETS.icons.composer.micPlain
      : mode === 'stop'
        ? WEB_ASSETS.icons.composer.stop
        : WEB_ASSETS.icons.composer.mic

  return (
    <span className={`${s.root} ${className ?? ''}`} aria-hidden="true">
      <Artwork asset={assets.light} className={s.light} />
      <Artwork asset={assets.dark} className={s.dark} />
    </span>
  )
}
